module.exports = __webpack_public_path__ + "static/media/instagram.0b6b3c8d.png";